import { createContext, ReactNode, useContext, useState } from 'react';

interface MonitoringAgentHomepageContextValue {
  flowMonitoringLoading: boolean;
  leadMonitoringLoading: boolean;
  setFlowMonitoringLoading: (loading: boolean) => void;
  setLeadMonitoringLoading: (loading: boolean) => void;
}

const MonitoringAgentHomepageContext = createContext<MonitoringAgentHomepageContextValue | null>(
  null,
);

export const useMonitoringAgentHomepageContext = (): MonitoringAgentHomepageContextValue => {
  const context = useContext(MonitoringAgentHomepageContext);
  if (!context) {
    throw new Error(
      'useMonitoringAgentHomepage must be used within an MonitoringAgentHomepageProvider',
    );
  }
  return context;
};

// Optional version that returns null if not within provider (for use in dialogs/portals)
export const useMonitoringAgentHomepageOptional =
  (): MonitoringAgentHomepageContextValue | null => {
    return useContext(MonitoringAgentHomepageContext);
  };

export const MonitoringAgentHomepageProvider = ({ children }: { children: ReactNode }) => {
  const [flowMonitoringLoading, setFlowMonitoringLoading] = useState(false);
  const [leadMonitoringLoading, setLeadMonitoringLoading] = useState(false);
  return (
    <MonitoringAgentHomepageContext.Provider
      value={{
        flowMonitoringLoading,
        leadMonitoringLoading,
        setFlowMonitoringLoading,
        setLeadMonitoringLoading,
      }}
    >
      {children}
    </MonitoringAgentHomepageContext.Provider>
  );
};
